import { ReactNode, useEffect } from 'react';
import { applyTheme } from './applyTheme';
import type { RestaurantTheme } from '@/types';

interface Props {
  theme: RestaurantTheme;
  children: ReactNode;
}

export default function ThemeProvider({ theme, children }: Props) {
  useEffect(() => {
    applyTheme(document.documentElement, theme);
  }, [theme]);

  return <>{children}</>;
}
